/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should I do during the 5-minute break?`)
};

const es_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué debo hacer durante el descanso de 5 minutos?`)
};

const de_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sollte ich während der 5-minütigen Pause tun?`)
};

const nl_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat moet ik doen tijdens de pauze van 5 minuten?`)
};

const fr_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que faire pendant la pause de 5 minutes ?`)
};

const it_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa dovrei fare durante la pausa di 5 minuti?`)
};

const pt_br2_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que devo fazer durante a pausa de 5 minutos?`)
};

const pt_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que devo fazer durante a pausa de 5 minutos?`)
};

const ja_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5分間の休憩中は何をすればいいですか？`)
};

const zh_timer_pomodoro_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5分钟休息时间应该做什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq3_q", locale)
	if (locale === "en") return en_timer_pomodoro_faq3_q(inputs)
	if (locale === "es") return es_timer_pomodoro_faq3_q(inputs)
	if (locale === "de") return de_timer_pomodoro_faq3_q(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq3_q(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq3_q(inputs)
	if (locale === "it") return it_timer_pomodoro_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq3_q(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq3_q(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq3_q(inputs)
	return zh_timer_pomodoro_faq3_q(inputs)
};